import { AccountModule } from './../account/account.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnonymousComponent } from './anonymous.component';
import { RouterModule } from '@angular/router';
import { AnonymousRoutes } from './anonymous.routing';
import { BrowserModule } from '@angular/platform-browser';
import { ServicesModule } from '../../app/services/services.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilsModule } from '../../app/utils/utils.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { UnsubscribedComponent } from './unsubscribed/unsubscribed.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
@NgModule({
  declarations: [AnonymousComponent, PrivacyPolicyComponent, TermsOfServiceComponent, UnsubscribedComponent],
  imports: [
    CommonModule,
    RouterModule,
    RouterModule.forChild(AnonymousRoutes),
    BsDatepickerModule.forRoot(),
    BrowserModule,
    ServicesModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    AccountModule,
  ],
  exports: [AnonymousComponent],
})
export class AnonymousModule {}
